export default {
  name: 'ListMixin',
  data () {
    return {
      btnLoading: false,
      loading: false,
      filterForm: {},
      // 列表数据
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      pageStart: 1,
      total: 0,
      getListApi: () => {},
    }
  },
  async created () {
    try {
      await this.init()
      await this.handleSearch()
    } catch (e) {
      this.$error(e)
    } finally {
      this.loading = false
    }
  },
  methods: {
    init () {
      return true
    },
    async handleSearch () {
      try {
        this.loading = true

        const { pageSize: rows, pageStart: page } = this

        const res = await this.getListApi({
          ...this.filterForm,
          rows,
          page,
        })

        this.tableData = res.data || res.results
        this.total = res.total
      } catch (e) {
        this.$error(e)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pageStart = 1
      this.currentPage = 1
      this.handleSearch()
    },
    handleCurrentChange (val) {
      this.pageStart = val
      this.currentPage = val
      this.handleSearch()
    },
  },

}
